import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Cta.css';

const Cta = ({ property, collection, scrollToAvailabilities }) => {
    const { _id, browse_availabilities_link, custom_office_brochure, custom_retail_brochure, custom_esg_brochure, website_link } = property;

    const brochureLink = custom_office_brochure && custom_office_brochure.length > 0 ? `${process.env.RAZZLE_ASSET_URL}${custom_office_brochure}` : null;
    const browseAvLink = browse_availabilities_link && browse_availabilities_link.length > 0 ? browse_availabilities_link : null;

    const retailBrochureLink = custom_retail_brochure && custom_retail_brochure.length > 0 ? `${process.env.RAZZLE_ASSET_URL}${custom_retail_brochure}` : null;
    const esgBrochureLink = custom_esg_brochure && custom_esg_brochure.length > 0 ? `${process.env.RAZZLE_ASSET_URL}${custom_esg_brochure}` : null;
    const websiteLink = website_link.length > 0 ? website_link : null;
    const collectionData =
        collection.find(element => {
            return (
                element.properties.find(property => {
                    return property === _id;
                }) && element.published
            );
        }) || null;
    const disableBrochure = !custom_office_brochure || custom_office_brochure.length === 0 ? true : false;
    const disableBrowseAv = !browse_availabilities_link || browse_availabilities_link.length === 0 ? true : false;
    const disableRetailBrochure = !custom_retail_brochure || custom_retail_brochure.length === 0 ? true : false;
    const disableESGBrochure = !custom_esg_brochure || custom_esg_brochure.length === 0 ? true : false;
    const disableWebsite = website_link.length === 0 ? true : false;
    const disableCollectionSlug = collectionData === null ? true : false;

    return (
        <section className="section section-cta">
            <div className="container">
                <div className="columns is-mobile">
                    <div className="column is-12-mobile is-10-tablet is-offset-1-tablet">
                        <div className="columns">
                            <div className="column is-12-mobile is-6-tablet">
                                <div className="columns is-mobile">
                                    <div className="column">
                                        {disableBrowseAv ? (
                                            <div className="cta cta-availabilities disabled">
                                                <button className="un-styled-button">
                                                    <svg className="icon icon-availabilities" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 332.8">
                                                        <path className="path" d="M137.79 38.4a9.6 9.6 0 1 1-9.6-9.6 9.6 9.6 0 0 1 9.6 9.6zm0 0" />
                                                        <path
                                                            className="path"
                                                            d="M256 76.8a25.6 25.6 0 0 0-25.6-25.6h-35.54A38.26 38.26 0 0 0 177 39.89a17.61 17.61 0 0 1-12.13-12.12 38.41 38.41 0 0 0-73.82 0A17.63 17.63 0 0 1 79 39.89 38.33 38.33 0 0 0 61.14 51.2H25.6A25.6 25.6 0 0 0 0 76.8v230.4a25.6 25.6 0 0 0 25.6 25.6h204.8a25.6 25.6 0 0 0 25.6-25.6V76.8zm-192-.21A25.73 25.73 0 0 1 82.49 52.2a30.36 30.36 0 0 0 20.9-20.9 25.62 25.62 0 0 1 49.22 0 30.33 30.33 0 0 0 20.89 20.89A25.72 25.72 0 0 1 192 76.8v12.8H64zM230.4 320H25.6a12.81 12.81 0 0 1-12.8-12.8V76.8A12.81 12.81 0 0 1 25.6 64h27.79a38.25 38.25 0 0 0-2.19 12.49v25.91h153.6V76.8a38.25 38.25 0 0 0-2.21-12.8h27.81a12.81 12.81 0 0 1 12.8 12.8v230.4a12.81 12.81 0 0 1-12.8 12.8zm0 0"
                                                        />
                                                        <path className="path" d="M181.21 155.61l-76.93 76.93-33.91-33.91-9.05 9.05 43 43 86-86zm0 0" />
                                                    </svg>
                                                    <div className="copy">
                                                        Browse <br /> Availabilities
                                                    </div>
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="cta cta-availabilities">
                                                <a className="link" href={browseAvLink} target="_blank" rel="noopener noreferrer">
                                                    <svg className="icon icon-availabilities" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 332.8">
                                                        <path className="path" d="M137.79 38.4a9.6 9.6 0 1 1-9.6-9.6 9.6 9.6 0 0 1 9.6 9.6zm0 0" />
                                                        <path
                                                            className="path"
                                                            d="M256 76.8a25.6 25.6 0 0 0-25.6-25.6h-35.54A38.26 38.26 0 0 0 177 39.89a17.61 17.61 0 0 1-12.13-12.12 38.41 38.41 0 0 0-73.82 0A17.63 17.63 0 0 1 79 39.89 38.33 38.33 0 0 0 61.14 51.2H25.6A25.6 25.6 0 0 0 0 76.8v230.4a25.6 25.6 0 0 0 25.6 25.6h204.8a25.6 25.6 0 0 0 25.6-25.6V76.8zm-192-.21A25.73 25.73 0 0 1 82.49 52.2a30.36 30.36 0 0 0 20.9-20.9 25.62 25.62 0 0 1 49.22 0 30.33 30.33 0 0 0 20.89 20.89A25.72 25.72 0 0 1 192 76.8v12.8H64zM230.4 320H25.6a12.81 12.81 0 0 1-12.8-12.8V76.8A12.81 12.81 0 0 1 25.6 64h27.79a38.25 38.25 0 0 0-2.19 12.49v25.91h153.6V76.8a38.25 38.25 0 0 0-2.21-12.8h27.81a12.81 12.81 0 0 1 12.8 12.8v230.4a12.81 12.81 0 0 1-12.8 12.8zm0 0"
                                                        />
                                                        <path className="path" d="M181.21 155.61l-76.93 76.93-33.91-33.91-9.05 9.05 43 43 86-86zm0 0" />
                                                    </svg>
                                                    <div className="copy">
                                                        Browse <br />
                                                        Availabilities
                                                    </div>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                    <div className="column">
                                        {disableBrochure ? (
                                            <div className={'cta cta-brochure disabled'}>
                                                <svg className="icon icon-brochure" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.11 31.81">
                                                    <path
                                                        className="path"
                                                        d="M.9 0h15.49a.89.89 0 0 1 .61.28l6.79 6.81a.8.8 0 0 1 .28.63v23.2a.9.9 0 0 1-.9.89H.9a.91.91 0 0 1-.9-.89V.9A.91.91 0 0 1 .9 0zm16.39 3.06v3.77h3.76zm-1.8-1.27H1.8V30h20.52V8.62h-5.93a.91.91 0 0 1-.9-.9zm0 0"
                                                    />
                                                </svg>
                                                <div className="copy">
                                                    Office <br /> Brochure
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="cta cta-brochure">
                                                <a className="link" href={brochureLink} target="_blank" rel="noopener noreferrer">
                                                    <svg className="icon icon-brochure" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.11 31.81">
                                                        <path
                                                            className="path"
                                                            d="M.9 0h15.49a.89.89 0 0 1 .61.28l6.79 6.81a.8.8 0 0 1 .28.63v23.2a.9.9 0 0 1-.9.89H.9a.91.91 0 0 1-.9-.89V.9A.91.91 0 0 1 .9 0zm16.39 3.06v3.77h3.76zm-1.8-1.27H1.8V30h20.52V8.62h-5.93a.91.91 0 0 1-.9-.9zm0 0"
                                                        />
                                                    </svg>
                                                    <div className="copy">
                                                        Office <br /> Brochure
                                                    </div>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                    <div className="column">
                                        {disableRetailBrochure ? (
                                            <div className={'cta cta-retail-brochure disabled'}>
                                                <svg className="icon icon-brochure" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.11 31.81">
                                                    <path
                                                        className="path"
                                                        d="M.9 0h15.49a.89.89 0 0 1 .61.28l6.79 6.81a.8.8 0 0 1 .28.63v23.2a.9.9 0 0 1-.9.89H.9a.91.91 0 0 1-.9-.89V.9A.91.91 0 0 1 .9 0zm16.39 3.06v3.77h3.76zm-1.8-1.27H1.8V30h20.52V8.62h-5.93a.91.91 0 0 1-.9-.9zm0 0"
                                                    />
                                                </svg>
                                                <div className="copy">
                                                    Retail <br /> Brochure
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="cta cta-retail-brochure">
                                                <a className="link" href={retailBrochureLink} target="_blank" rel="noopener noreferrer">
                                                    <svg className="icon icon-brochure" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.11 31.81">
                                                        <path
                                                            className="path"
                                                            d="M.9 0h15.49a.89.89 0 0 1 .61.28l6.79 6.81a.8.8 0 0 1 .28.63v23.2a.9.9 0 0 1-.9.89H.9a.91.91 0 0 1-.9-.89V.9A.91.91 0 0 1 .9 0zm16.39 3.06v3.77h3.76zm-1.8-1.27H1.8V30h20.52V8.62h-5.93a.91.91 0 0 1-.9-.9zm0 0"
                                                        />
                                                    </svg>
                                                    <div className="copy">
                                                        Retail <br /> Brochure
                                                    </div>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="column is-12-mobile is-6-tablet">
                                <div className="columns is-mobile">
                                    <div className="column">
                                        {disableESGBrochure ? (
                                            <div className={'cta cta-retail-brochure disabled'}>
                                                <svg className="icon icon-brochure" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.11 31.81">
                                                    <path
                                                        className="path"
                                                        d="M.9 0h15.49a.89.89 0 0 1 .61.28l6.79 6.81a.8.8 0 0 1 .28.63v23.2a.9.9 0 0 1-.9.89H.9a.91.91 0 0 1-.9-.89V.9A.91.91 0 0 1 .9 0zm16.39 3.06v3.77h3.76zm-1.8-1.27H1.8V30h20.52V8.62h-5.93a.91.91 0 0 1-.9-.9zm0 0"
                                                    />
                                                </svg>
                                                <div className="copy">
                                                    ESG <br /> Brochure
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="cta cta-retail-brochure">
                                                <a className="link" href={esgBrochureLink} target="_blank" rel="noopener noreferrer">
                                                    <svg className="icon icon-brochure" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.11 31.81">
                                                        <path
                                                            className="path"
                                                            d="M.9 0h15.49a.89.89 0 0 1 .61.28l6.79 6.81a.8.8 0 0 1 .28.63v23.2a.9.9 0 0 1-.9.89H.9a.91.91 0 0 1-.9-.89V.9A.91.91 0 0 1 .9 0zm16.39 3.06v3.77h3.76zm-1.8-1.27H1.8V30h20.52V8.62h-5.93a.91.91 0 0 1-.9-.9zm0 0"
                                                        />
                                                    </svg>
                                                    <div className="copy">
                                                        ESG <br /> Brochure
                                                    </div>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                    <div className="column">
                                        {disableWebsite ? (
                                            <div className="cta cta-website disabled">
                                                <svg className="icon icon-website" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 64">
                                                    <rect className="rect" x="1.5" y="1.5" width="76" height="50" rx="6" ry="6" />
                                                    <path className="path" d="M1.5 39.5h76" />
                                                    <circle className="circle" cx="39.5" cy="45.5" r="2" />
                                                    <path className="path" d="M26.5 62.5h26M32.5 50.5v11M46.5 50.5v11" />
                                                </svg>
                                                <div className="copy">
                                                    Visit <br /> Website
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="cta cta-website">
                                                <a className="link" href={websiteLink} target="_blank" rel="noopener noreferrer">
                                                    <svg className="icon icon-website" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 64">
                                                        <rect className="rect" x="1.5" y="1.5" width="76" height="50" rx="6" ry="6" />
                                                        <path className="path" d="M1.5 39.5h76" />
                                                        <circle className="circle" cx="39.5" cy="45.5" r="2" />
                                                        <path className="path" d="M26.5 62.5h26M32.5 50.5v11M46.5 50.5v11" />
                                                    </svg>
                                                    <div className="copy">
                                                        Visit <br /> Website
                                                    </div>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                    <div className="column">
                                        {disableCollectionSlug ? (
                                            <div className="cta cta-collection disabled">
                                                <svg className="icon icon-collection" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.04 63">
                                                    <path className="path" d="M1.5 62.55V1.5h46.04v60h-47" />
                                                    <path
                                                        className="path"
                                                        d="M7.54 7.5h14v14h-14zM27.54 7.5h14v14h-14zM7.54 26.5h14v14h-14zM27.54 26.5h14v14h-14z"
                                                    />
                                                    <path className="path" d="M13 60V48a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v12" transform="translate(.54 .5)" />
                                                </svg>
                                                <div className="copy">
                                                    View <br /> Collection
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="cta cta-collection">
                                                <Link className="link" to={collectionData.slug}>
                                                    <svg className="icon icon-collection" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.04 63">
                                                        <path className="path" d="M1.5 62.55V1.5h46.04v60h-47" />
                                                        <path
                                                            className="path"
                                                            d="M7.54 7.5h14v14h-14zM27.54 7.5h14v14h-14zM7.54 26.5h14v14h-14zM27.54 26.5h14v14h-14z"
                                                        />
                                                        <path className="path" d="M13 60V48a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2v12" transform="translate(.54 .5)" />
                                                    </svg>
                                                    <div className="copy">
                                                        View <br /> Collection
                                                    </div>
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

Cta.propTypes = {
    collection: PropTypes.array,
    property: PropTypes.object.isRequired,
    scrollToAvailabilities: PropTypes.func.isRequired,
};

export default connect(
    ({ content }) => ({
        collection: content.collection,
    }),
    null
)(Cta);
